import { useRef } from 'react';

export const useClickOrDrag = (
  onClick: (e: MouseEvent | TouchEvent) => void,
  dragThreshold = 5
) => {
  const startX = useRef(0);
  const startY = useRef(0);
  const moved = useRef(false);

  const handleStart = (x: number, y: number) => {
    startX.current = x;
    startY.current = y;
    moved.current = false;
  };

  const handleMove = (x: number, y: number) => {
    const dx = Math.abs(x - startX.current);
    const dy = Math.abs(y - startY.current);
    if (dx > dragThreshold || dy > dragThreshold) {
      moved.current = true;
    }
  };

  const handleEnd = (e: MouseEvent | TouchEvent) => {
    if (!moved.current) {
      onClick(e);
    }
  };

  const onMouseDown = (e: React.MouseEvent) => {
    handleStart(e.clientX, e.clientY);

    const onMouseMove = (moveEvent: MouseEvent) => {
      handleMove(moveEvent.clientX, moveEvent.clientY);
    };

    const onMouseUp = (e: MouseEvent) => {
      handleEnd(e);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const onTouchStart = (e: React.TouchEvent) => {
    const touch = e.touches[0];
    if (touch) {
      handleStart(touch.clientX, touch.clientY);
    }

    const onTouchMove = (moveEvent: TouchEvent) => {
      const moveTouch = moveEvent.touches[0];
      if (moveTouch) {
        handleMove(moveTouch.clientX, moveTouch.clientY);
      }
    };

    const onTouchEnd = (e: TouchEvent) => {
      handleEnd(e);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    };

    document.addEventListener('touchmove', onTouchMove, { passive: true });
    document.addEventListener('touchend', onTouchEnd);
  };

  return { onMouseDown, onTouchStart };
};
